import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../api/client';

export default function ReportsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['full-stats'],
    queryFn: () => api.get('/stats'),
  } as any);

  const s = (data as any)?.data;

  const STAT_CARDS = [
    { label:'სულ წიგნი', val:s?.books, color:'var(--accent)', bg:'var(--accent-bg)', icon:'ti-books' },
    { label:'აქტიური წევრი', val:s?.members, color:'var(--success)', bg:'var(--success-bg)', icon:'ti-users' },
    { label:'გაცემული', val:s?.active_checkouts, color:'var(--warning)', bg:'var(--warning-bg)', icon:'ti-arrows-exchange' },
    { label:'ვადაგადაცილებული', val:s?.overdue, color:'var(--danger)', bg:'var(--danger-bg)', icon:'ti-alert-triangle' },
    { label:'დაბრუნებული', val:s?.returned, color:'#a78bfa', bg:'#1a0d2e', icon:'ti-check' },
    { label:'გადაუხდელი ჯარიმა', val:s?.unpaid_fines ? `₾${Number(s.unpaid_fines).toFixed(2)}` : '₾0', color:'#38bdf8', bg:'#0a1f2e', icon:'ti-coin' },
  ];

  const monthly = s?.monthly_stats || [];
  const maxMonth = Math.max(...monthly.map((m: any) => m.count), 1);

  const collStats = s?.collection_stats || [];
  const maxColl = Math.max(...collStats.map((c: any) => c.count), 1);

  if (isLoading) return <div style={{padding:24,color:'var(--text-faint)',fontFamily:'system-ui,sans-serif'}}>იტვირთება...</div>;

  return (
    <div style={{padding:24,fontFamily:'system-ui,sans-serif'}}>
      <div style={{marginBottom:24}}>
        <h1 style={{fontSize:20,fontWeight:600,color:'var(--text-primary)',margin:0}}>ანგარიშები</h1>
        <p style={{fontSize:12,color:'var(--text-faint)',marginTop:4}}>ბიბლიოთეკის სტატისტიკა და ანალიტიკა</p>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12,marginBottom:20}}>
        {STAT_CARDS.map(sc => (
          <div key={sc.label} style={{background:'var(--bg-card)',border:'1px solid #1e2d45',borderRadius:12,padding:16,display:'flex',alignItems:'center',gap:12}}>
            <div style={{width:40,height:40,borderRadius:10,background:sc.bg,color:sc.color,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
              <i className={`ti ${sc.icon}`} style={{fontSize:20}} />
            </div>
            <div>
              <div style={{fontSize:11,color:'var(--text-faint)',marginBottom:3}}>{sc.label}</div>
              <div style={{fontSize:22,fontWeight:700,color:sc.color}}>{sc.val?.toLocaleString?.() ?? sc.val ?? '...'}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
        <div style={{background:'var(--bg-card)',border:'1px solid #1e2d45',borderRadius:12,overflow:'hidden'}}>
          <div style={{padding:'14px 16px',borderBottom:'1px solid #1e2d45',display:'flex',alignItems:'center',gap:8}}>
            <span style={{width:3,height:14,borderRadius:2,background:'#3b82f6',display:'inline-block'}}></span>
            <span style={{fontSize:13,fontWeight:500,color:'var(--text-secondary)'}}>ყველაზე მეტად გაცემული</span>
          </div>
          {(s?.top_books||[]).map((b: any, i: number) => (
            <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'11px 16px',borderBottom:'1px solid #0f1826'}}>
              <div style={{width:24,height:24,borderRadius:6,background:'var(--bg-active)',border:'1px solid #2a3f6e',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,color:'var(--accent)',flexShrink:0}}>{i+1}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:500,color:'var(--text-secondary)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{b.title}</div>
                <div style={{fontSize:11,color:'var(--text-faint)'}}>{b.author}</div>
              </div>
              <span style={{padding:'2px 8px',borderRadius:6,fontSize:11,background:'var(--accent-bg)',color:'var(--accent)',fontWeight:500,flexShrink:0}}>{b.checkout_count}×</span>
            </div>
          ))}
        </div>

        <div style={{background:'var(--bg-card)',border:'1px solid #1e2d45',borderRadius:12,overflow:'hidden'}}>
          <div style={{padding:'14px 16px',borderBottom:'1px solid #1e2d45',display:'flex',alignItems:'center',gap:8}}>
            <span style={{width:3,height:14,borderRadius:2,background:'#10b981',display:'inline-block'}}></span>
            <span style={{fontSize:13,fontWeight:500,color:'var(--text-secondary)'}}>კოლექციები</span>
          </div>
          {collStats.map((c: any, i: number) => (
            <div key={i} style={{padding:'10px 16px',borderBottom:'1px solid #0f1826'}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:5}}>
                <span style={{fontSize:12,color:'var(--text-secondary)'}}>{c.name||'სხვა'}</span>
                <span style={{fontSize:12,fontWeight:600,color:'var(--text-primary)'}}>{Number(c.count).toLocaleString()}</span>
              </div>
              <div style={{height:4,background:'var(--border)',borderRadius:2,overflow:'hidden'}}>
                <div style={{height:'100%',width:`${(c.count/maxColl)*100}%`,background:'#10b981',borderRadius:2}} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{background:'var(--bg-card)',border:'1px solid #1e2d45',borderRadius:12,overflow:'hidden'}}>
        <div style={{padding:'14px 16px',borderBottom:'1px solid #1e2d45',display:'flex',alignItems:'center',gap:8}}>
          <span style={{width:3,height:14,borderRadius:2,background:'#f59e0b',display:'inline-block'}}></span>
          <span style={{fontSize:13,fontWeight:500,color:'var(--text-secondary)'}}>გაცემები თვეების მიხედვით (ბოლო 12 თვე)</span>
        </div>
        <div style={{padding:20}}>
          {monthly.length === 0
            ? <p style={{textAlign:'center',color:'var(--text-dimmed)',fontSize:13}}>მონაცემი არ არის</p>
            : (
              <div style={{display:'flex',alignItems:'flex-end',gap:6,height:140}}>
                {monthly.map((m: any, i: number) => {
                  const h = Math.max((m.count / maxMonth) * 120, 4);
                  return (
                    <div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',gap:4}}>
                      <span style={{fontSize:10,color:'var(--accent)',fontWeight:500}}>{m.count}</span>
                      <div style={{width:'100%',height:h,background:'#1d4ed8',borderRadius:'4px 4px 0 0',minHeight:4}} />
                      <span style={{fontSize:9,color:'var(--text-dimmed)',transform:'rotate(-45deg)',transformOrigin:'center',whiteSpace:'nowrap'}}>
                        {m.month?.slice(5)}
                      </span>
                    </div>
                  );
                })}
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}
